/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, string, func, bool, number,
} from 'prop-types';
import {  selectedSkuType, clubComponentType } from '../common/types';
import DesktopMobile from '../../../../../helpers/DesktopMobile/DesktopMobile';
import ClubPDPImageDesktop from './ClubPDPImageDesktop';
import ClubPDPImageMobile from './ClubPDPImageMobile';

const GraphqlClubPDPImage = ({
    modalOpen,
    handleState,
    product,
    cdnLink,
    clubComponents,
    getSlides,
    selectedComponentMonth,
    navigate,
    renderZoom,
    shouldRenderSnipe,
    getClubLengthDescription,
    selectedSku,
    presentation_family,
    renderSnipe,
    heroImage,
    personalizationFlag,
    longDescription,
}) => (
    <DesktopMobile
        breakpoint={960}
        desktop={() => (
            <div data-testid="desktop-render">
                <ClubPDPImageDesktop
                    modalOpen={modalOpen}
                    handleState={handleState}
                    product={product}
                    cdnLink={cdnLink}
                    clubComponents={clubComponents}
                    getSlides={getSlides}
                    selectedComponentMonth={selectedComponentMonth}
                    navigate={navigate}
                    renderZoom={renderZoom}
                    shouldRenderSnipe={shouldRenderSnipe}
                    getClubLengthDescription={getClubLengthDescription}
                    selectedSku={selectedSku}
                    presentation_family={presentation_family}
                    renderSnipe={renderSnipe}
                    heroImage={heroImage}
                    personalizationFlag={personalizationFlag}
                    longDescription={longDescription}
                />
            </div>
        )}
        mobile={() => (
            <div data-testid="mobile-render">
                <ClubPDPImageMobile
                    data-testid="mobile-render"
                    modalOpen={modalOpen}
                    handleState={handleState}
                    product={product}
                    cdnLink={cdnLink}
                    clubComponents={clubComponents}
                    getSlides={getSlides}
                    selectedComponentMonth={selectedComponentMonth}
                    navigate={navigate}
                    renderZoom={renderZoom}
                    shouldRenderSnipe={shouldRenderSnipe}
                    getClubLengthDescription={getClubLengthDescription}
                    selectedSku={selectedSku}
                    presentation_family={presentation_family}
                    renderSnipe={renderSnipe}
                    heroImage={heroImage}
                    personalizationFlag={personalizationFlag}
                    longDescription={longDescription}
                />
            </div>
        )}
    />
);

GraphqlClubPDPImage.defaultProps = {
    getSlides: () => {},
    modalOpen: false,
    handleState: () => {},
    product: {},
    cdnLink: '',
    selectedComponentMonth: 0,
    navigate: () => { },
    renderZoom: () => { },
    shouldRenderSnipe: () => { },
    getClubLengthDescription: () => { },
    selectedSku: {},
    presentation_family: 'food',
    renderSnipe: func,
    heroImage: '',
    personalizationFlag: false,
    longDescription: '',
};

GraphqlClubPDPImage.propTypes = {
    longDescription: string,
    clubComponents: clubComponentType.isRequired,
    getSlides: func,
    modalOpen: bool,
    handleState: func,
    product: object,
    cdnLink: string,
    selectedComponentMonth: number,
    navigate: func,
    renderZoom: func,
    shouldRenderSnipe: func,
    getClubLengthDescription: func,
    selectedSku: selectedSkuType,
    presentation_family: string,
    renderSnipe: func,
    heroImage: string,
    personalizationFlag: bool,
};

export default GraphqlClubPDPImage;
